import request from '@/utils/request'

let Document_sectionsApi = {

  /*文档子内容列表*/
  list(data) {
    return request._post('/shop/plus.document_sections.Index/index', data);
},
/*添加文档子内容*/
add(data) {
    return request._post('/shop/plus.document_sections.Index/add', data);
},
/*修改文档子内容*/
edit(data) {
    return request._post('/shop/plus.document_sections.Index/edit', data);
},
/*删除文档子内容*/
del(data) {
    return request._post('/shop/plus.document_sections.Index/del', data);
},
/*文档子内容详情*/
detail(data) {
  return request._post('/shop/plus.document_sections.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.document_sections.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.document_sections.Setting/getSetting', data, errorback);
    },
}
export default Document_sectionsApi;



// WEBPACK FOOTER //
// ./src/api/document_sections.js